// Map ISO country codes → Flutterwave-supported currencies we offer at checkout.
// Anything else falls back to USD.
export const COUNTRY_TO_FLW_CURRENCY = {
  NG: 'NGN',
  KE: 'KES',
  GH: 'GHS',
  ZA: 'ZAR',
};

const SUPPORTED = new Set(['NGN', 'KES', 'GHS', 'ZAR', 'USD']);

// Guess currency from browser language tag first (fast, offline).
function currencyFromNavigator() {
  try {
    const langs = [navigator.language, ...(navigator.languages || [])];
    for (const raw of langs) {
      const region = String(raw || '').split('-')[1]?.toUpperCase();
      if (region && COUNTRY_TO_FLW_CURRENCY[region]) return COUNTRY_TO_FLW_CURRENCY[region];
    }
  } catch { /* no-op */ }
  return null;
}

/**
 * Detect the buyer's most-likely Flutterwave currency.
 * Order: navigator.language → ipapi.co (CORS-friendly, no key) → fallback.
 */
export async function detectFlwCurrency(fallback = 'USD') {
  const fromNav = currencyFromNavigator();
  if (fromNav) return fromNav;
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    const r = await fetch('https://ipapi.co/country/', { signal: controller.signal });
    clearTimeout(timeout);
    const country = (await r.text()).trim().toUpperCase();
    if (COUNTRY_TO_FLW_CURRENCY[country]) return COUNTRY_TO_FLW_CURRENCY[country];
  } catch { /* network / CORS / timeout — silently fall back */ }
  return SUPPORTED.has(fallback) ? fallback : 'USD';
}
